import type { QueueItem } from "../../hooks/useUploadQueue.js";

interface UploadOverallProgressProps {
  items: QueueItem[];
  isUploading: boolean;
}

export function UploadOverallProgress({ items, isUploading }: UploadOverallProgressProps) {
  if (items.length === 0) return null;

  // Weighted by bytes rather than by file count: a 20MB video sitting at
  // 50% should move the needle more than a 200KB photo that just finished.
  const totalBytes = items.reduce((sum, it) => sum + it.file.size, 0);
  const doneBytes = items.reduce((sum, it) => {
    if (it.status === "done") return sum + it.file.size;
    if (it.status === "uploading") return sum + it.file.size * it.progress;
    return sum;
  }, 0);
  const fraction = totalBytes > 0 ? doneBytes / totalBytes : 0;
  const doneCount = items.filter((it) => it.status === "done").length;
  const errorCount = items.filter((it) => it.status === "error").length;

  return (
    <div className="card stack" style={{ padding: "var(--space-4)" }}>
      {isUploading && (
        <p style={{ margin: 0, color: "var(--color-primary)", fontWeight: 600, fontSize: "0.9rem" }}>
          Ne fermez pas cette page tant que l'envoi est en cours.
        </p>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.9rem" }}>
        <span>
          {doneCount} / {items.length} fichier(s) envoyé(s)
          {errorCount > 0 ? ` · ${errorCount} en erreur` : ""}
        </span>
        <span>{Math.round(fraction * 100)}%</span>
      </div>
      <div
        style={{
          height: 8,
          borderRadius: 999,
          background: "var(--color-border)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${Math.round(fraction * 100)}%`,
            height: "100%",
            background: "var(--color-primary)",
            transition: "width 0.2s ease",
          }}
        />
      </div>
    </div>
  );
}
